import { useParams } from "react-router-dom";
import { Statement } from "@/components/Statement";
import { StatementCharts } from "@/components/StatementCharts";
import { PdfButton, ReportList, useReportPage } from "@/components/ReportShell";
import { NoData } from "@/components/NoData";

const isEntity = (e) => e.kind === "entity" && (e.has_data || e.owner_count > 0);

export default function EntityReports() {
  const { id } = useParams();
  const { api, period, rows, rep } = useReportPage(isEntity, "/reports/entities", id);
  if (!period) return <NoData />;
  return (
    <div className="max-w-[1400px]">
      <div className="flex flex-wrap items-end justify-between gap-4 no-print">
        <div>
          <h1 className="font-serif text-4xl sm:text-5xl lg:text-6xl tracking-tight">Entity Valuations</h1>
          <p className="text-slate-500 mt-3">Assets, liabilities, owners and investment detail for each entity.</p>
        </div>
        <PdfButton api={api} url={`/reports/entities/pdf?period=${period}`} name={`Entity_Valuation_Reports_${period}.pdf`}
          label="Download all (PDF)" variant="outline" testid="pdf-download-all-button" />
      </div>
      <div className="grid lg:grid-cols-[300px_1fr] gap-8 mt-10">
        <div className="no-print"><ReportList rows={rows} activeId={id} base="/reports/entities" testid="entity-report-list" /></div>
        <div className="min-w-0">
          {rep ? (
            <>
              <div className="flex justify-end gap-2 mb-4 no-print">
                <PdfButton api={api} url={`/reports/entity/${rep.entity.id}/pdf?period=${period}`} name="report.pdf" />
              </div>
              <div className="fade-up"><StatementCharts entityId={rep.entity.id} rows={rep.assets} title="Asset mix" period={rep.period} /><Statement rep={rep} title="Entity Valuation Report" /></div>
            </>
          ) : (
            <p className="small-label">Loading statement…</p>
          )}
        </div>
      </div>
    </div>
  );
}
